<div [ngClass]="{'tw-hidden': !activeEmailThread}">
    <!-- Begin Header -->
    <div class="email-content-header-container tw-p-3 tw-border tw-min-h-[75px] tw-max-h-[75px]">
        <div class="tw-grid tw-grid-cols-4">
            <div class="email-content-contact-names tw-col-span-3 tw-whitespace-nowrap tw-text-ellipsis tw-overflow-hidden">
                <div *ngIf="toRecipientRecords?.length > 0; else other">
                    To:  <span *ngFor="let recipient of toRecipientRecords; let isLast = last;" [matTooltip]="recipient.email" matTooltipPosition="above">{{ recipient.name }}<span *ngIf="!isLast">, </span></span>
                    <span *ngIf="bccRecipientRecords?.length > 0">
                        Bcc: <span *ngFor="let bccRecipient of bccRecipientRecords; let isLast = last;" [matTooltip]="bccRecipient.email" matTooltipPosition="above">{{ bccRecipient.name }}<span *ngIf="!isLast">, </span></span>
                    </span>
                </div>
                <ng-template #other>
                    <span *ngIf="showAsMarketing; else automated">Marketing</span>
                    <ng-template #automated>Automated</ng-template>
                    <span *ngIf="toRecipientRecords?.length > 0">
                        , <span *ngFor="let recipient of toRecipientRecords; let isLast = last;" [matTooltip]="recipient.email" matTooltipPosition="above">{{ recipient.name }}<span *ngIf="!isLast">, </span></span>
                    </span>
                </ng-template>
            </div>
            <div class="tw-col-span-1 tw-flex tw-flex-row tw-place-content-end">
                <div *ngIf="activeEmailThread?.attachmentCount" class="tw-flex tw-flex-row items-center tw-mr-2">
                    <div class="email-content-attachment-number tw-text-sm">{{ activeEmailThread.attachmentCount }}</div>
                    <mat-icon class="email-content-attachment-icon tw-text-ls tw-mr-3">attachment</mat-icon>
                </div>
                <div class="email-content-date tw-text-sm">{{ activeEmailThread?.modifiedTimestamp * 1000 | date: 'MMM d' }}</div>
            </div>
        </div>
        <div class="email-content-subject-title tw-mt-2 tw-whitespace-nowrap tw-text-ellipsis tw-overflow-hidden">Subject:
            <span class="email-content-subject-text">{{ subject }}</span>
            <span *ngIf="!!messageCount && messageCount > 1" class="email-content-message-count tw-ml-2">({{ messageCount }})</span>
        </div>
    </div>
    <!-- End Header -->
    <!-- Begin Display email body -->
    <div class="email-content-container tw-mb-3">
        <div class="tw-h-[820px] tw-overflow-hidden tw-overflow-y-scroll" #emailContentContainer>
            <div *ngFor="let message of activeEmailThread?.messages; trackBy: trackById; let messageIndex = index; let isFirst = first; let isLast = last; let thread = activeEmailThread;">
                <div *ngIf="message.hubspotEmailTemplateId || message.recipientCount === 0; else inbox">
                    <!-- Marketing -->
                    <app-marketing-email-message
                    [message]="message"
                    [thread]="activeEmailThread"
                    [isLast]="isLast"
                    [borrower]="borrower"
                    [joinedContacts]="joinedContacts"
                    (handleEmailCreate)="handleEmailCreate($event)"
                    (scrollIntoView)="scrollIntoView($event)"
                    ></app-marketing-email-message>
                </div>
                <ng-template #inbox>
                    <!-- Inbox -->
                    <app-inbox-email-message
                    [message]="message"
                    [thread]="activeEmailThread"
                    [isLast]="isLast"
                    [borrower]="borrower"
                    [joinedContacts]="joinedContacts"
                    (handleEmailCreate)="handleEmailCreate($event)"
                    (scrollIntoView)="scrollIntoView($event)"
                    ></app-inbox-email-message>
                </ng-template>
            </div>
        </div>
    </div>
    <!-- End Display email body -->
</div>

<div [ngClass]="{'tw-hidden': !loadingActiveEmailThread}">
    <div class="tw-flex tw-flex-col tw-items-center tw-w-full tw-pr-2 tw-pt-64" *ngIf="loadingActiveEmailThread">
        <mat-progress-spinner  [color]="'primary'" [diameter]="40" mode="indeterminate" ></mat-progress-spinner>
        <div class="tw-text-lg tw-mt-8">Loading Emails</div>
    </div>
</div>
